// Module Federation bootstrap pattern - async boundary for shared dependencies
import('./bootstrap')

